import axios from "axios";

export const useHelper = () => {
  const MAX_CHUNK_SIZE = 100 * 1024

  const getSizeInBytes = (data) => new TextEncoder().encode(JSON.stringify(data)).length;

  function splitChunkRecursively(chunk) {
    const chunkSize = getSizeInBytes(chunk)
    if (chunkSize <= MAX_CHUNK_SIZE || chunk.length === 1) {
      return [chunk]
    }
  
    const mid = Math.floor(chunk.length / 2)
    const leftChunks = splitChunkRecursively(chunk.slice(0, mid))
    const rightChunks = splitChunkRecursively(chunk.slice(mid))
  
    return [...leftChunks, ...rightChunks]
  }

  function createSmartChunks(data) {
    const initialChunks = []
    const chunkSize = 100
  
    for (let i = 0; i < data.length; i += chunkSize) {
      initialChunks.push(data.slice(i, i + chunkSize))
    }
  
    return initialChunks.flatMap((chunk) => splitChunkRecursively(chunk))
  }

  return {
    createSmartChunks,
  };
};

